<template>
  <div class="text-lg mb-4 text-left">รายการ {{ props.title }}</div>
  <form class="flex flex-row justify-between sm:mr-auto">
    <div class="sm:flex items-center sm:mr-4 gap-4">
      <select
        v-model="optionSelected"
        class="form-select w-full xxl:w-full mt-2 sm:mt-0 sm:w-auto"
        :disabled="props.isEdit"
      >
        <option :value="null">เลือก {{ props.title }}</option>
        <option v-for="opt in options" :key="opt.value" :value="opt.value">{{
          opt.label
        }}</option>
      </select>
      <!-- new -->
      <select
        id="tabulator-html-filter-field"
        v-model="vendorSelected"
        class="form-select w-full sm:w-48 xxl:w-full sm:mt-0"
      >
        <option :value="null">เลือก Vendor</option>
        <option
          v-for="opt in vendorInOFOptions"
          :key="opt.value"
          :value="opt.value"
          >{{ opt.label }}</option
        >
      </select>
      <!-- <div class="sm:flex items-center sm:mr-4 xl:mt-0">
        <label
          class="w-12 flex-none xl:w-auto xl:flex-initial mr-2 hidden sm:block"
          >ค้นหา</label
        >
        <input
          id="tabulator-html-filter-value"
          v-model="filter.value"
          type="text"
          class="form-control sm:w-40 xxl:w-full sm:mt-0"
          :placeholder="filterPlaceholder"
        />
      </div> -->
      <div class="xl:mt-0 gap-2 sm:gap-0 flex flex-row">
        <button
          id="tabulator-html-filter-go"
          type="button"
          class="btn btn-primary w-full sm:w-16"
          @click="onFilter"
        >
          ค้นหา
        </button>
        <button
          id="tabulator-html-filter-reset"
          type="button"
          class="btn btn-secondary w-full sm:w-16 mt-0 sm:ml-1"
          @click="onResetFilter"
        >
          เคลียร์
        </button>
      </div>
    </div>
    <div>
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        v-show="props.btnClosed"
        @click="closed"
      >
        ปิด
      </button>
      <button
        type="button"
        class="btn btn-warning"
        data-dismiss="modal"
        v-show="props.btnConfirm"
        @click="confirmItem"
      >
        ยืนยัน
      </button>
    </div>
  </form>
  <div
    id="tabulator"
    ref="tableRef"
    class="mt-5 table-report table-report--tabulator"
  ></div>
  <div class="text-left mt-4 text-red-400">
    <span
      ><b>หมายเหตุ</b> เมื่อมีการเลือกรายการสินค้าใหม่ และยืนยัน
      จะทำให้รายการก่อนหน้าถูกลบทิ้ง</span
    >
  </div>
</template>

<script>
import Tabulator from 'tabulator-tables'
// import { defineComponent, ref, onMounted, computed, watch } from 'vue'
import { defineComponent, ref, reactive, onMounted, watch, computed } from 'vue'
// import { useStore } from '@/store'
import helpers from '@/helpers'
import feather from 'feather-icons'
export default defineComponent({
  name: 'table-list-selected-rf',
  props: {
    title: {
      type: String,
      default: () => 'ไม่ระบุ'
    },
    data: {
      type: Array,
      required: true,
      default: () => null
    },
    hasOption: {
      type: Boolean,
      default: () => false
    },
    fieldOptions: {
      type: Object,
      default: () => {
        return {
          label: 'label',
          value: 'value'
        }
      }
    },
    btnConfirm: {
      type: Boolean,
      default: () => true
    },
    btnClosed: {
      type: Boolean,
      default: () => true
    },
    isEdit: {
      type: Boolean,
      default: () => false
    },
    itemsSelected: {
      type: Array,
      default: () => []
    },
    // mainSelected: {
    //   type: Object,
    //   default: () => null
    // },
    displayStatus: {
      type: String,
      default: () => 'hide'
    },
    vendorInOFOptions: {
      type: Array,
      default: () => []
    }
  },
  emits: ['confirm', 'closed'],
  setup(props, context) {
    const optionSelected = ref(null)
    const vendorSelected = ref(null)
    const options = ref([])
    const tableRef = ref()
    const tabulator = ref()
    const chosen = ref([])
    const chosenItems = ref([])
    const items = ref([])
    const { numberFormat } = helpers
    const data = computed(() => props.data)
    const itemDelete = ref([])
    const currentVendor = ref(null)
    const currentVendorCount = ref(0)
    // const currentVendorItem = ref([])

    const statusOption = ref([])
    const companyOption = ref([])
    const filter = reactive({
      field: '',
      type: 'like',
      value: '',
      companySelected: '',
      statusSelected: ''
    })

    const genOptions = () => {
      const labels = props.fieldOptions.label.split(',')
      options.value = data.value.map(item => {
        const val = labels.map(f => (item[f] ? item[f] : 'ไม่ระบุ'))
        return {
          label: val.join(' - '),
          value: item[props.fieldOptions.value]
        }
      })
      clearData()
    }

    const clearData = () => {
      chosen.value = []
      optionSelected.value = null
      chosenItems.value = []
      itemDelete.value = []
      tabulator.value.setData(chosenItems.value)
      currentVendor.value = null
      currentVendorCount.value = 0
    }

    const pushItem = item => {
      items.value.push(item)
    }

    const pushChosen = docNoFull => {
      // console.log('find of header')
      if (!chosen.value.find(r => r.doc_no_full == docNoFull)) {
        const tmp = props.data.find(r => r.doc_no_full == docNoFull)
        if (tmp) {
          chosen.value.push({
            of_id: tmp.of_id,
            of_no: tmp.of_no,
            of_comp: tmp.of_comp,
            doc_no_full: tmp.doc_no_full,
            req_detail: tmp.req_detail,
            doc_title: tmp.doc_title,
            req_date: tmp.req_date,
            req_date_text: tmp.req_date_text,
            currency_code: tmp.currency_code,
            bu_no: tmp.bu_no,
            bu_name: tmp.bu_name,
            telephone: tmp.telephone,
            file_attach: tmp.file_attach,
            file_attach_array: tmp.file_attach_array,
            ememo_id: tmp.ememo_id,
            ememo_title: tmp.ememo_title,
            ememo_link: tmp.ememo_id
              ? `${process.env.VUE_APP_BASE_URL}/memo/myActivities/form/${tmp.ememo_id}/detail`
              : null,
            reason_chosen_vendor: tmp.reason_chosen_vendor,
            order_type_text: tmp.order_type_text,
            selected: tmp.selected
          })
        }
      }
    }

    const removeChosen = docNoFull => {
      const countDocNoFull = items.value.filter(r => r.doc_no_full == docNoFull)
      if (countDocNoFull.length == 0) {
        const newChosen = chosen.value.filter(r => r.doc_no_full != docNoFull)
        chosen.value = newChosen
      }
      console.log('remove chosen step 2: ', countDocNoFull.length)
    }

    const initTabulator = async () => {
      tabulator.value = new Tabulator(tableRef.value, {
        ajaxLoader: true,
        placeholder: 'ไม่พบข้อมูลที่ต้องการ',
        paginationSize: 10,
        paginationSizeSelector: [10, 20, 30, 40],
        data: chosenItems.value,
        columns: [
          {
            title: 'เลือก',
            field: 'of_item_id',
            formatter: cell => {
              const btn = cash(`<div class="flex lg:justify-center items-center">
                <button type="button" class="btn btn-selected-of" data-vendor="${
                  cell.getData().vendor_code
                }" data-of-id="${
                cell.getData().of_item_id
              }"><i data-feather="check-square" class="w-4 h-4 mr-1"></i> เลือก</button>
              </div>`)

              console.log('rebuild')

              // if (cell.getData().amount != 0 || cell.getData().qty != 0) {
              cash(btn).on('click', e => {
                let selected = false
                if (
                  cash(btn)
                    .find('button')
                    .hasClass('btn-warning')
                ) {
                  removeItem(cell.getData().of_item_id)
                  removeChosen(cell.getData().doc_no_full)
                  cash(btn)
                    .find('button')
                    .removeClass('btn-warning')
                    .addClass('btn-outline-secondary')
                  selected = false
                } else {
                  pushItem(cell.getData())
                  pushChosen(cell.getData().doc_no_full)
                  cash(btn)
                    .find('button')
                    .removeClass('btn-outline-secondary')
                    .addClass('btn-warning')
                  selected = true
                }

                if (currentVendor.value === null) {
                  console.log(
                    'currentVendor:',
                    e.target.dataset.vendor,
                    cash(e).data('vendor')
                  )
                  currentVendor.value = e.target.dataset.vendor
                  currentVendorCount.value = 1
                } else if (currentVendor.value == e.target.dataset.vendor) {
                  if (selected) {
                    currentVendorCount.value++
                  } else {
                    currentVendorCount.value--
                    if (currentVendorCount.value == 0) {
                      currentVendor.value = null
                    }
                  }
                }
                checkDisabledBtnOF()
              })
              // }
              return btn[0]
            }
          },
          {
            title: 'เลขที่เอกสาร',
            field: 'doc_no_full',
            width: 120
          },
          {
            title: 'Vender',
            field: 'vender_code',
            width: '500',
            formatter: cell => {
              // console.log('cell:', cell.getData())
              return (
                cell.getData().vendor_code + ' - ' + cell.getData().vendor_name
              )
            }
          },
          {
            title: 'รายละเอียดสินค้า',
            field: 'item_name',
            width: '500'
          },
          {
            title: 'จำนวนสินค้า',
            field: 'qty',
            hozAlign: 'right',
            formatter: cell => {
              return numberFormat(cell.getData().qty)
            }
          },
          {
            title: 'หน่วยนับ',
            field: 'uom'
          },
          {
            title: 'รวมเป็นเงินทั้งหมด',
            field: 'actual_cost',
            hozAlign: 'right',
            formatter: cell => {
              return numberFormat(cell.getData().actual_cost)
            }
          },
          {
            title: 'สถานที่รับสินค้า',
            field: 'pickup_loc',
            hozAlign: 'left',
            width: 500
          }
        ],
        renderComplete() {
          console.log('render table list selected OF')
          feather.replace({
            'stroke-width': 1.5
          })
          items.value.map(r => {
            cash(
              '.btn-selected-of[data-of-id="' + r.of_item_id + '"]'
            ).addClass('btn-warning')
          })
          if (currentVendor.value != null) {
            checkDisabledBtnOF()
          }
        }
      })
    }

    const checkDisabledBtnOF = () => {
      cash('.btn-selected-of').each((i, e) => {
        // console.log(
        //   'e: ',
        //   i,
        //   items.value,
        //   currentVendor.value != cash(e).data('vendor'),
        //   currentVendor.value,
        //   cash(e).data('vendor')
        // )
        if (
          currentVendor.value != cash(e).data('vendor') &&
          currentVendorCount.value > 0
        ) {
          cash(e)
            .addClass('btn-secondary-soft')
            .attr('disabled', true)
            .removeClass('btn-warning')
        } else if (currentVendorCount.value > 0 && items.value.length > 0) {
          // cash(e).addClass('btn-warning')
        }

        if (currentVendorCount.value == 0) {
          cash(e)
            .removeClass('btn-secondary-soft')
            .removeAttr('disabled')
        }
      })
    }

    const removeItem = ofItemId => {
      const oldItems = items.value.find(item => item.of_item_id == ofItemId)
      if (oldItems) {
        itemDelete.value.push(oldItems)
      }
      const newItems = items.value.filter(item => item.of_item_id !== ofItemId)
      items.value = newItems
      console.log('remove item step 1. ', newItems)
    }

    const findItem = () => {
      if (optionSelected.value !== null) {
        chosen.value = data.value.find(
          item => item[props.fieldOptions.value] == optionSelected.value
        )
      } else {
        clearData()
      }
    }

    const onFilter = () => {
      // clear value
      chosen.value = []
      chosenItems.value = []
      itemDelete.value = []
      items.value = []
      currentVendor.value = null
      currentVendorCount.value = 0

      // find item list
      // console.log('onFilter: ', optionSelected.value, vendorSelected.value)
      if (optionSelected.value !== null && vendorSelected.value === null) {
        const newItem = []
        for (const i in data.value) {
          if (data.value[i][props.fieldOptions.value] == optionSelected.value) {
            const tmp = data.value[i].items.filter(r => r)
            newItem.push(...tmp)
          }
        }
        chosenItems.value = newItem
        setSelectedItems(newItem)
      } else if (
        optionSelected.value === null &&
        vendorSelected.value !== null
      ) {
        const newItem = []
        for (const i in data.value) {
          const tmp = data.value[i].items.filter(r => {
            if (r.vendor_code == vendorSelected.value) {
              return r
            }
          })
          newItem.push(...tmp)
        }
        chosenItems.value = newItem
        setSelectedItems(newItem)
      } else if (
        optionSelected.value !== null &&
        vendorSelected.value !== null
      ) {
        const newItem = []
        for (const i in data.value) {
          if (data.value[i][props.fieldOptions.value] == optionSelected.value) {
            const tmp = data.value[i].items.filter(r => {
              if (r.vendor_code == vendorSelected.value) {
                return r
              }
            })
            newItem.push(...tmp)
          }
        }
        chosenItems.value = newItem
        setSelectedItems(newItem)
      } else {
        clearData()
      }
    }

    const setSelectedItems = data => {
      // console.log('set selected items: ', data)
      const newData = data.map(d => {
        d.selected = !!props.itemsSelected.find(
          s => s.of_item_id == d.of_item_id
        )
        return d
      })
      tabulator.value.setData(newData)
    }

    const onResetFilter = () => {
      optionSelected.value = null
      vendorSelected.value = null
      chosen.value = []
      chosenItems.value = []
      items.value = []
      itemDelete.value = []
      currentVendor.value = null
      currentVendorCount.value = 0
      setSelectedItems([])
    }

    // watch(chosen, newVal => {
    //   console.log('watch chosen newVal: ', chosen, newVal)

    //   if (newVal !== null && newVal !== undefined) {
    //     chosenItems.value = chosen.value.items
    //     // chosenItems.value = chosen.value
    //     setSelectedItems(chosenItems.value)
    //     itemDelete.value = []
    //     if (props.mainSelected) {
    //       items.value =
    //         newVal.po_id === props.mainSelected.po_id
    //           ? [...props.itemsSelected]
    //           : []
    //     } else {
    //       items.value = []
    //     }
    //   }
    // })

    const confirmItem = () => {
      context.emit('confirm', {
        chosen: [...chosen.value],
        chosenItems: [...items.value]
      })
      context.emit('closed')
    }

    const closed = async () => {
      context.emit('closed')
      if (props.mainSelected) {
        optionSelected.value = props.mainSelected.po_id
        await findItem()
      }
      items.value = props.itemsSelected
    }

    watch(
      () => props.data,
      newVal => {
        console.log('watch data')
        if (props.hasOption) {
          genOptions()
        }
      }
    )

    watch(
      () => props.displayStatus,
      newVal => {
        console.log('watch modal display: ', newVal)
        if (newVal == 'open') {
          items.value = [...props.itemsSelected]
          setSelectedItems(chosenItems.value)
        } else {
          itemDelete.value = []
        }
      }
    )

    onMounted(() => {
      initTabulator()
      if (props.hasOption) {
        genOptions()
      }
    })

    return {
      tableRef,
      optionSelected,
      vendorSelected,
      options,
      findItem,
      chosen,
      chosenItems,
      confirmItem,
      itemDelete,
      closed,
      items,
      props,
      statusOption,
      companyOption,
      filter,
      onFilter,
      onResetFilter,
      currentVendor,
      currentVendorCount
    }
  }
})
</script>
